var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right_container",style:({height:_vm.height+'px',width:_vm.width+'px'})},[_c('div',{staticClass:"default_page",style:({top:(_vm.height/2-15)+'px'})},[_vm._v("\n      欢迎使用海南白马广告媒体投资有限公司项目管理系统！\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-83f625c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/page/auditing/welcome.vue
// module id = null
// module chunks = 